// WARNING: DO NOT EDIT.  This file is automatically generated
// Written by aws-amplify-serverless-plugin/1.4.1 on 2023-01-10T18:15:35.224Z

const awsmobile = {
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_appsync_graphqlEndpoint: 'https://en7llbzpsrd5rmhkh6p3dc27gi.appsync-api.eu-central-1.amazonaws.com/graphql',
    aws_appsync_region: 'eu-central-1',
    aws_cognito_region: 'eu-central-1',
    aws_project_region: 'eu-central-1',
    aws_user_files_s3_bucket: 'gst-backend-gsttest-assetsbucket-bmtw8tfnd2zp',
    aws_user_files_s3_bucket_region: 'eu-central-1',
    aws_user_pools_id: 'eu-central-1_2dHYfoXSh',
    aws_user_pools_web_client_id: 'k84342kstvmtn123gooblj6ac'
};

export default awsmobile;